import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import NumberInput from '../../atoms/NumberInput';

export type FormNumberInputProps<T extends FieldValues, TTransformedValues = T> = {
  name: Path<T>;
  control: Control<T, unknown, TTransformedValues>;
} & Omit<React.ComponentProps<typeof NumberInput>, 'value' | 'name'>;

const FormNumberInput = <T extends FieldValues, TTransformedValues = T>({
  name,
  control,
  onChange,
  ...otherProps
}: FormNumberInputProps<T, TTransformedValues>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <NumberInput
          {...field}
          {...otherProps}
          onChange={onChange ?? field.onChange}
          error={!!error}
          helperText={error?.message}
        />
      )}
    />
  );
};

export default FormNumberInput;
